import PropTypes from 'prop-types'
import React from 'react'

const Magnifier = ({item, width, height, children}) => {
  return (
    <div className='magnifier' style={{width}}>
      <div className='size-limiter' style={{height}}>
        {children}
      </div>
      <strong>{item.name}</strong>
      <div className='info'>
        <div className='author-category'>
          by <span className='author'>{item.author_username}</span>
          <span className='category'>{item.formattedClassification}</span>
        </div>
        {item.price ? <div className='price'>
          <span className='cost'><sup>$</sup>{item.price}</span>
        </div> : null}
      </div>
    </div>
  )
}

Magnifier.propTypes = {
  item: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number
}

export default Magnifier



// WEBPACK FOOTER //
// ./client/components/magnifier/magnifier.js